/**
 * Helpers for the forbidden_topic_keywords chip input.
 *
 * Mirrors the BE _redact_forbidden_sentences contract: matching is
 * case-insensitive, but stored keywords keep the operator's casing, so dedupe
 * compares lowercased forms.
 */

const cleanKeyword = (raw: string): string => raw.trim().replace(/,$/, '');

export const addForbiddenKeyword = (
  existing: readonly string[],
  raw: string,
): string[] => {
  const cleaned = cleanKeyword(raw);
  if (!cleaned) return [...existing];
  const lower = cleaned.toLowerCase();
  if (existing.some((k) => k.toLowerCase() === lower)) {
    return [...existing];
  }
  return [...existing, cleaned];
};

export const removeForbiddenKeyword = (
  existing: readonly string[],
  keyword: string,
): string[] => existing.filter((k) => k !== keyword);

export const popLastForbiddenKeyword = (
  existing: readonly string[],
): string[] => existing.slice(0, -1);
